import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ArtToolsService
{
  private readonly apiURLprefix : string = '/api/art-tools';
  renderServerURL: string = "https://flora-render.dev.petunia.gardenjoygame.com/renderserver/test"


  constructor(private http: HttpClient) {}

  /**
   * Sync Resources for Build
   */
  async syncResources(): Promise<any>
  {
    return await firstValueFrom(this.http.get<any>(`${this.apiURLprefix}/sync-resources`));
  }

  /**
   * Sync Resources for Build (v2 - parallel downloads)
   */
  async syncResourcesV2(): Promise<any>
  {
    return await firstValueFrom(this.http.get<any>(`${this.apiURLprefix}/sync-resources/v2`));
  }

  generateImagePath(entityId: number, type: string){
    if(type=="items"){
      return `${this.renderServerURL}/2791/1024/${entityId}.jpg`
    } else {
      return `${this.renderServerURL}/${entityId}/1024/0.jpg`
    }
  }
}
